import { render, staticRenderFns } from "./xy-not-tip.vue?vue&type=template&id=b7e1d7e0&scoped=true"
import script from "./xy-not-tip.vue?vue&type=script&lang=js"
export * from "./xy-not-tip.vue?vue&type=script&lang=js"
import style0 from "./xy-not-tip.vue?vue&type=style&index=0&id=b7e1d7e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e1d7e0",
  null
  
)

export default component.exports